import { Routes, Route } from 'react-router-dom'
import { NavigateWithThread } from '../navigate-with-thread'
import { FocusDashboard } from '../focus-dashboard'
import { AdminLayout } from '../admin/admin-layout'
import { AgentEvaluationsPage } from '../developer/agent-evaluations-page'

interface DeveloperRoutesProps {
  onStartConversation?: (message: string) => void
}

export function DeveloperRoutes({ onStartConversation }: DeveloperRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard
            focus="developer"
            onStartConversation={onStartConversation}
          />
        }
      />
      <Route
        path="agent-evaluations"
        element={
          <AdminLayout>
            <AgentEvaluationsPage />
          </AdminLayout>
        }
      />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
